<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <v-card>
          <v-img class="white--text" height="700px" src="https://source.unsplash.com/random">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span class="headline">Commission Whiz</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4>
        <material-card color="green" title="Login">
          <v-form @submit.prevent="login" autocomplete="off">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="email"
                    class="purple-input"
                    label="Email"
                    name="email"
                    v-validate="'required|email|max:250'"
                    :error-messages="errors.collect('email')"
                  />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="pass"
                    class="purple-input"
                    label="Password"
                    type="password"
                    name="password"
                    v-validate="'required'"
                    :error-messages="errors.collect('password')"
                  />
                </v-flex>

                <v-flex xs12 text-xs-right>
                  <v-btn type="submit" class="mx-0 font-weight-light" color="success">Submit</v-btn>
                </v-flex>
                <p v-if="error" class="error">Bad login information</p>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import auth from "./auth";
import UserService from "@/api-services/user.service.js";

export default {
  mounted() {
    console.log(process.env);
  },
  data() {
    return {
      email: "",
      pass: "",
      error: false,
      claims: "",
      current_user: {}
    };
  },
  methods: {
    login() {
      this.$validator.validateAll().then(result => {
        //Clear tokens
        auth.logout();
        if (result) {
          auth.login(this.email, this.pass, loggedIn => {
            console.log(loggedIn);
            if (!loggedIn) {
              console.log("login failed");
              this.$toasted.show("Nice try. Invalid credentails !", {
                theme: "bubble",
                position: "bottom-right",
                duration: 5000,
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                }
              });
            } else {
              console.log("login success");
              console.log(auth.getName());
              console.log(auth.getId());

              UserService.getUserByVendorId (auth.getId())
                .then(response => {
                  var user = response.data.user[0];
                  this.current_user = user;
                  this.$store.commit("setCurrentUser", this.current_user);
              this.$store.commit("setLayout", "layout");
              this.$router.replace(this.$route.query.redirect || "/");
                })
                .catch(error => {
                  console.log(error.response.data);
                });
              
            }
          });
        }
      });
    }
  }
};
</script>
